import React, { useEffect, useRef, useState } from "react";
import Highcharts, { chart } from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import "./charting.css";
import success from "../Assets/success.mp3";
import lose from "../Assets/lose.mp3";
import {
  TableOutlined,
  CheckCircleFilled,
  LoadingOutlined,
} from "@ant-design/icons";
import LotDrop from "./LotDrop";
import LotDropForex from "./LotDropForex";
import { Avatar, Button, Input, Modal, notification, Spin, Tabs } from "antd";
import ExpirationDrop from "./ExpirationDrop";
import { message, Card, Space, Typography, Tag } from "antd"; // ✅ only if using Ant Design
import Axios from "../Axios";
import lower from "../Assets/lower.png";
import $ from "jquery";
import { useLayout } from "../Context/LayoutContext";
import wbg from "../Assets/wbg.png";
import wbg2 from "../Assets/wbg2.png";
import { Col, Row, Grid, Tooltip } from "antd";
import IntervalDrop from "./IntervalDrop";
import consts from "../consts";
import OrderBookPanel from "../Components/OrderBook";
import { ArrowLeftOutlined, RightCircleOutlined } from "@ant-design/icons";
import { L1, L3, L4 } from "../SvgCollections";
import { createRoot } from "react-dom/client";

// Load all Highcharts modules
import { useParams } from "react-router-dom";
import { useChartData } from "../Context/chartContext";
import { useFutureData } from "../Context/futureContext";
import { useCommodityData } from "../Context/commodityContext";
import { type } from "@testing-library/user-event/dist/type";
import PlaceOrder from "./PlaceOrder";
import OrderBook from "../Components/OrderBookAnt";
import { motion, AnimatePresence, useAnimation } from "framer-motion";
import {
  CloseOutlined,
  AreaChartOutlined,
  ControlOutlined,
  DownOutlined,
} from "@ant-design/icons";
import forexMobileView from "./forexMobileView";
import axios from "axios";

const { Text } = Typography;

const { useBreakpoint } = Grid;

const mockAsks = [
  { price: 87501.8, amount: 0.0006, total: 0.11 },
  { price: 87501.5, amount: 0.0012, total: 0.21 },
  { price: 87501.3, amount: 0.0038, total: 0.5 },
];

const mockBids = [
  { price: 87499.8, amount: 0.014, total: 0.14 },
  { price: 87499.4, amount: 0.032, total: 0.47 },
  { price: 87499.0, amount: 0.055, total: 1.02 },
];

function getLanguageFromURL() {
  const regex = new RegExp("[\\?&]lang=([^&#]*)");
  const results = regex.exec(window.location.search);
  return results === null
    ? null
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}
function generateMockBars(latestPrice, numBars = 100) {
  const basePrice = Number(latestPrice);
  if (!Number.isFinite(basePrice) || basePrice <= 0) return [];

  const bars = [];
  let currentPrice = basePrice;

  for (let i = numBars - 1; i >= 0; i--) {
    const close = currentPrice;
    const change = Math.random() * 0.002 - 0.001; // ±0.1% random move
    const open = close / (1 + change); // reverse calculation to keep trend continuous

    const high = Math.max(open, close) * (1 + Math.random() * 0.0008);
    const low = Math.min(open, close) * (1 - Math.random() * 0.0008);

    bars.push({
      time: Date.now() - i * 2 * 60 * 1000, // each bar = 2 minutes earlier
      open: +open.toFixed(5),
      high: +high.toFixed(5),
      low: +low.toFixed(5),
      close: +close.toFixed(5),
    });

    // prepare for previous bar (go slightly backward)
    currentPrice = open;
  }

  return bars;
}

// const binanceInterval = {
//   1: "1",
//   3: "3",
//   5: "5",
//   15: "15",
//   30: "30",
//   60: "60",
//   120: "120",
//   240: "240",
//   360: "360",
//   720: "720",
//   "1D": "D",
//   "1W": "W",
//   "1M": "M",
// };
const normalizeExchangeSymbol = (symbol) => String(symbol || "").replace(/[_/]/g, "").toUpperCase();
const binanceInterval = {
  "1": "1m",
  "3": "3m",
  "5": "5m",
  "15": "15m",
  "30": "30m",
  "60": "1h",
  "120": "2h",
  "240": "4h",
  "360": "6h",
  "480": "8h",
  "720": "12h",
  "1D": "1d",
  "3D": "3d",
  "1W": "1w",
  "1M": "1M",
};
export default function Forexchart({ chartId, tab, forceCompact, onTabType }) {
  // const [interval, setInterval] = useState("1m");
  const screen = useBreakpoint();

  const wsRef = useRef(null);
  const leverage = 300;
  const chartContainerRef = useRef();
  console.log(chartContainerRef, "chartContainerRef");

  const [active, setActive] = useState("chart"); // chart | orderbook
  const {
    priceRef,
    tvWidgetRef,
    lineRefs,
    registerChart,
    unregisterChart,
    handleRemoveAllLines,
    registerLines,
  } = useChartData();

  const {
    getFutureTicker,
    futureTvWidgetRef,
    futureLinesRef,
    futureRegisterChart,
    futureUnregisterChart,
    handleFutureRemoveAllLines,
    futureRegisterLines,
  } = useFutureData();

  const { getCommodityTicker, commodityPriceRef, generateCommodityHistoryBars } =
    useCommodityData();
  console.log(getCommodityTicker("XAU/USD"), "chartId");
  const [chartType, setChartType] = useState(
    localStorage.getItem("chartType") || "candlestick",
  );
  const initialloadRef = useRef(true);

  const theme = localStorage.getItem("theme");
  const [range, setRange] = useState(localStorage.getItem("range") || "1m"); // default

  const chartRef = useRef(null);
  const {
    mode,
    setMode,
    activeLay,
    onEdit,
    getTradeHistory,
    openOrders,
    getPositions,
    positions,
    percent,
    getWallet,
    futureLeverage,
    setTriggerForexOrders,
    wallet,
    escrow,
    setEscrow,
    tradeHistory,
    openShowOrderBook,
    setshowOrderBookk,
    tabs,
    activeKey,
    setActiveKey,
    activeFtpage,
    isMatchedIndex,
    showDrawer,
  } = useLayout();
  const [openPortfolioDrawer, setOpenPortfolioDrawer] = useState(false);
  const currencyPair =
    tab?.typ == "forex"
      ? tab?.title.toLowerCase()
      : tab?.typ === "commodities"
        ? tab?.title.toUpperCase()
        : tab?.title.replace("/", "").toLowerCase();
  // Maps any commodity title → AllTick DOM class key (GOLD, Silver, Platinum)
  const getCommodityDomKey = (title = "") => {
    const MAP = {
      GOLD: "GOLD", XAUUSD: "GOLD", XAU: "GOLD",
      SILVER: "Silver", XAGUSD: "Silver", XAG: "Silver",
      PLATINUM: "Platinum", XPTUSD: "Platinum", XPT: "Platinum",
    };
    return MAP[String(title).replace(/[/_]/g, "").toUpperCase()] ?? title;
  };

  // const { priceRef } = useChartData();
  localStorage.setItem("currencyPair", currencyPair);

  const [activeTabType, setActiveTabType] = useState(null);

  const [quantity, setQuantity] = useState(
    tab?.typ === "forex" || tab?.typ === "commodities" ? 0.01 : 0.001,
  );
  const [tradePrice, setTradePrice] = useState(0);
  const [profitAmount, setProfitAmount] = useState(0);
  const [orderBook, setOrderBook] = useState({
    bids: [],
    asks: [],
    lastUpdateId: 0,
  });
  const localOB = useRef({
    bids: [],
    asks: [],
    lastUpdateId: 0,
  });
  const [tradeProfit, setTradeProfit] = useState(0);

  const [tradeLoss, setTradeLoss] = useState(0);
  const [priceTrade, setPriceTrade] = useState(0);

  const [historyReloadKey, setHistoryReloadKey] = useState(0);
  const { isCompact } = useLayout();
  const compactMode = forceCompact !== undefined ? forceCompact : isCompact;
  const [payoutPercent, setPayoutPercent] = useState(0.1);
  const [isModalTpOpen, setIsModalTpOpen] = useState(false);
  const [isModalSlOpen, setIsModalSlOpen] = useState(false);
  const [stopLoss, setStopLoss] = useState(0);
  const [takeProfit, setTakeProfit] = useState(0);
  const [pointValue, setPointValue] = useState(0.01);
  const [load, setLoad] = useState({ buy: false, sell: false });

  const showTpModal = () => setIsModalTpOpen(true);
  const showSLModal = () => setIsModalSlOpen(true);

  const handleTpCancel = () => {
    setTakeProfit(0);
    setTradeProfit(0);
    setIsModalTpOpen(false);
  };
  const handleSlCancel = () => {
    setStopLoss(0);
    setTradeLoss(0);
    setIsModalSlOpen(false);
  };

  const handleTpOk = () => setIsModalTpOpen(false);
  const handleSlOk = () => setIsModalSlOpen(false);

  const subscriptionSockets = {};
  const handleChange = (e) => {
    const value = Number(e.target.value);
    setQuantity(value);

    const profit = (value * percent) / 100;
    setPayoutPercent(profit);
    const total = Number(value + profit).toFixed(2);

    setProfitAmount(total);

    setTradeProfit(value);
    setTradeLoss(value);
    setPriceTrade(value);
  };
  // const [price2, setPrice2] = useState(null);
  const [plotLines, setPlotLines] = useState([]);
  const inputRef = useRef(null);
  const [isRunning, setIsRunning] = useState(false);
  const [focused, setFocused] = useState(0);
  // const lastCandle = initialData[initialData.length - 1];
  const [initialData, setInitialData] = useState([]); // store historical candles
  const [expSec, setExpSec] = useState(0);
  const [kchange, setKchange] = useState(false);

  const [lastestBar, setLastestBar] = useState({});
  const [state, setState] = useState(false);
  const executeOnce = useRef(false);
  const [isMobile, setIsMobile] = useState(false);
  const ref2 = useRef(null);
  const [collapsedHistory, setCollapsedHistory] = useState(true);
  // const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const orderBookSymbol = tab?.title
    ? tab.title.replace(/\//g, "").toUpperCase()
    : "";
  const topBid = Number(orderBook.bids?.[0]?.[0] || 0);
  const topAsk = Number(orderBook.asks?.[0]?.[0] || 0);
  const orderBookMidPrice =
    topBid && topAsk
      ? (topBid + topAsk) / 2
      : Number(
        getFutureTicker(orderBookSymbol)?.markPrice ||
        getFutureTicker(orderBookSymbol)?.midprice ||
        priceRef.current?.[tab?.title]?.midPrice ||
        0,
      );

  //fore trading view
  // useEffect(() => {
  //   getTradeHistory("pending");
  // }, []);
  //notification

  // tab varirents
  const tabVariants = {
    hidden: { opacity: 0, x: 15 },
    visible: { opacity: 1, x: 0, transition: { duration: 1 } },
    exit: { opacity: 0, x: -15, transition: { duration: 0.25 } },
  };
  // const showLabel = !isMobile || (isMobile && isActive);

  const [priceLoading, setPriceLoading] = useState(true);

  useEffect(() => {
    if (
      priceRef.current[tab?.title] &&
      priceRef.current[tab?.title]?.midPrice &&
      priceRef.current[tab?.title]?.spread
    )
      return;
    const interval = setInterval(() => {
      if (
        priceRef.current[tab?.title] &&
        priceRef.current[tab?.title]?.midPrice &&
        priceRef.current[tab?.title]?.spread
      ) {
        setPriceLoading(false);
      } else {
        setPriceLoading(true);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tab]);
  const openNotification = (qty, sl, tp) => {
    const parent = document.querySelector(".not-cls"); // 👈 your DOM parent selector

    notification.open({
      message: null,
      description: (
        <div className="card">
          <div className="img">
            <img src={tab?.imgSrc} alt="icon" />
          </div>
          <div className="textBox">
            <div className="textContent">
              <p className="h1">{currencyPair?.toUpperCase()}</p>
              <p className="p">Qty: {qty}</p>
            </div>
            <div className="display-6">
              <p className="p">
                TP/SL: {tp} / {sl}
              </p>
            </div>

            <p className="p plc">
              Order Placed <CheckCircleFilled style={{ color: "green" }} />
            </p>
            <div className="display-6"></div>

            {/* <div className="display-2">
              <p className="p">
                TP: <CheckCircleFilled style={{ color: "green" }} />
              </p>
              <p className="p">
                SL: <CheckCircleFilled style={{ color: "green" }} />
              </p>
            </div> */}
          </div>
        </div>
      ),
      className: "custom-ant-notification",
      icon: null,
      duration: 6,
      closeIcon: true,
      placement: "top",
      getContainer: () => parent || document.body, // <-- renders inside your DOM parent
    });
  };

  useEffect(() => {
    if (onTabType && tab?.typ) {
      onTabType(tab.typ);
    }
  }, [tab]);

  const onPortfolioClose = () => {
    setOpenPortfolioDrawer(false);
    // setCollapsedHistory(true);
  };
  const onOrderBookClose = () => {
    setshowOrderBookk(false);
    // setCollapsedHistory(true);
  };

  const id = useParams().id;

  useEffect(() => {
    console.log(openOrders, "openOrders");
    const widgetRef =
      tab.typ === "future" ? futureTvWidgetRef.current : tvWidgetRef.current;
    const widget = widgetRef[chartId];
    if (!widget) return;

    widget.onChartReady(() => {
      if (tab.typ === "future") {
        const tpsls = positions?.filter(
          (p) => p?.symbol?.replace("_", "/") === tab?.title,
        );
        if (!tpsls?.length) {
          handleFutureRemoveAllLines(chartId);
          return;
        }

        handleFutureRemoveAllLines(chartId);
        handleTpSl(
          tpsls[0]?.take_profit,
          tpsls[0]?.stop_loss,
          tpsls[0]?.entry_price,
          "future",
        );
      } else if (tab.typ === "forex") {
        const activeOrders = openOrders?.filter(
          (p) =>
            p?.symbol?.replace("_", "/") === tab?.title &&
            p?.status === "Pending",
        );
        console.log(
          !activeOrders?.length > 0,
          !activeOrders?.length,
          activeOrders,
          chartId,
          "activeOrders",
        );
        if (!activeOrders?.length) {
          console.log(!activeOrders?.length, "activeOrders true");
          handleRemoveAllLines(chartId);
          return;
        }

        handleRemoveAllLines(chartId);
        handleTpSl(
          activeOrders[0]?.take_profit,
          activeOrders[0]?.stop_loss,
          activeOrders[0]?.price,
          "forex",
        );
      }
    });
  }, [positions, openOrders, chartId, tab.typ]);
  const syncOrderBookState = (ob) => {
    ob.bids.sort((a, b) => Number(b[0]) - Number(a[0]));
    ob.asks.sort((a, b) => Number(a[0]) - Number(b[0]));
    ob.bids = ob.bids.slice(0, 30);
    ob.asks = ob.asks.slice(0, 30);

    setOrderBook({
      bids: [...ob.bids],
      asks: [...ob.asks],
      lastUpdateId: ob.lastUpdateId,
    });
  };

  const mergeOrderBookSide = (levels, updates) => {
    const nextLevels = [...levels];

    updates.forEach(([price, qty]) => {
      const levelPrice = String(price);
      const levelQty = String(qty);
      const idx = nextLevels.findIndex(([p]) => String(p) === levelPrice);

      if (Number(levelQty) === 0) {
        if (idx >= 0) nextLevels.splice(idx, 1);
        return;
      }

      if (idx >= 0) {
        nextLevels[idx] = [levelPrice, levelQty];
      } else {
        nextLevels.push([levelPrice, levelQty]);
      }
    });

    return nextLevels;
  };

  const updateOrderBook = (message) => {
    console.log(message, "orderbook message");
    const data = message?.data || message;
    if (!data) return;
    const ob = localOB.current;
    const bids = Array.isArray(data?.b) ? data.b : [];
    const asks = Array.isArray(data?.a) ? data.a : [];

    ob.bids = bids
      .filter(([, qty]) => Number(qty) > 0)
      .map(([price, qty]) => [String(price), String(qty)])
      .sort((a, b) => Number(b[0]) - Number(a[0]));
    ob.asks = asks
      .filter(([, qty]) => Number(qty) > 0)
      .map(([price, qty]) => [String(price), String(qty)])
      .sort((a, b) => Number(a[0]) - Number(b[0]));
    ob.lastUpdateId = Number(data?.u || ob.lastUpdateId || 0);

    syncOrderBookState(ob);
  };

  useEffect(() => {
    console.log(tab.typ, tab.title, "tab.typ changed");
    if (tab.typ !== "future") return;

    // ✅ RESET ORDER BOOK WHEN SYMBOL CHANGES
    localOB.current = {
      bids: [],
      asks: [],
      lastUpdateId: 0,
    };
    setOrderBook({ bids: [], asks: [], lastUpdateId: 0 });

    const symbol = tab.title.replace(/\//g, "").toUpperCase();
    const socket = new WebSocket(
      `wss://fstream.binance.com/stream?streams=${symbol.toLowerCase()}@depth20@100ms`,
    );
    wsRef.current = socket;

    socket.onmessage = (event) => {
      try {
        const payload = JSON.parse(event.data);
        updateOrderBook(payload);
      } catch (e) {
        console.log("WS ERROR:", e);
      }
    };

    socket.onerror = (err) => {
      console.log("Socket error:", err);
    };

    socket.onclose = () => {
      if (wsRef.current === socket) {
        wsRef.current = null;
      }
    };

    return () => {
      try {
        socket.close();
      } catch (e) { }
      if (wsRef.current === socket) {
        wsRef.current = null;
      }
    };
  }, [tab.title, tab.typ]);

  //timer
  const handlePipChange = (value, type) => {
    try {
      const pipSize = tab.title.includes("JPY") ? 0.01 : 0.0001;
      const units = quantity * 100000;
      const symbol = tab?.title;
      const { ask: buy, bid: sell } = priceRef.current[symbol];
      // console.log(buy, sell, symbol, priceRef.current, 'buy');

      const price = (Number(buy) + Number(sell)) / 2;
      let pipValueUSD;
      // if (tab.title.endsWith("USD")) {
      //     pipValueUSD = pipSize * units;
      // } else {
      pipValueUSD = (pipSize * units) / price;
      // }
      if (type === "tp") {
        setTakeProfit(value);
        const profitUSD = Number(value) * pipValueUSD;
        setTradeProfit(parseFloat(profitUSD.toFixed(2)));
      } else if (type === "sl") {
        setStopLoss(value);
        const lossUSD = Number(value) * pipValueUSD;
        setTradeLoss(parseFloat(lossUSD.toFixed(2)));
      }
    } catch (error) {
      console.log(error, "errorpip");
    }
  };

  const handlePointChange = (value, type) => {
    try {
      if (type === "tp") {
        setTakeProfit(value);
        setTradeProfit(Number(value) * Number(pointValue));
      } else if (type === "sl") {
        setStopLoss(value);
        setTradeLoss(Number(value) * Number(pointValue));
      }
    } catch (error) {
      console.log(error, "errorpip");
    }
  };

  const handleFutureProfitChange = (value, type) => {
    try {
      if (type === "tp") {
        setTradeProfit(value);
        setTakeProfit(value / pointValue);
      } else {
        setTradeLoss(value);
        setStopLoss(value / pointValue);
      }
      console.log(value);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTradeProfitChange = (value) => {
    try {
      const pipSize = tab.title.includes("JPY") ? 0.01 : 0.0001;
      const units = quantity * 100000;
      const symbol = tab?.title;
      const { ask: buy, bid: sell } = priceRef.current[symbol];
      const price = (buy + sell) / 2;
      let pipValueUSD;
      // if (tab.title.endsWith("USD")) {
      //     pipValueUSD = pipSize * units;
      // } else {
      pipValueUSD = (pipSize * units) / price;
      // }
      const pips = Number(value) / pipValueUSD;
      setTradeProfit(parseFloat(value.toFixed(2)));
      setTakeProfit(parseFloat(pips.toFixed(1)));
    } catch (error) {
      console.log(error);
    }
  };

  const handleStopLossChange = (value) => {
    try {
      const pipSize = tab.title.includes("JPY") ? 0.01 : 0.0001;
      const units = quantity * 100000;
      const symbol = tab?.title;
      const { ask: buy, bid: sell } = priceRef.current[symbol];
      const price = (buy + sell) / 2;
      let pipValueUSD;

      // if (tab.title.endsWith("USD")) {
      //     pipValueUSD = pipSize * units;
      // } else {
      pipValueUSD = (pipSize * units) / price;
      // }

      const pips = Number(value) / pipValueUSD;

      setTradeLoss(parseFloat(value.toFixed(2)));
      setStopLoss(parseFloat(pips.toFixed(1)));
    } catch (error) {
      console.log(error);
    }
  };

  const CustomTabLabel = (row, i) => {
    console.log(row, "rowtab");
    const isActive = row.key === activeKey;

    const showLabel = !isMobile || (isMobile && isActive);
    const showCloseIcon = isMobile && tabs.length > 1;

    const handleClose = (e) => {
      e.stopPropagation();
      onEdit(row.key, "remove");
    };
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "5px 25px",
          borderBottom: "2px solid #fff",
        }}
        className={i <= isMatchedIndex ? "match-logic" : "no-logic x2"}
      >
        <img src={row.imgSrc} alt={row.imgSrc} width={25} height={25} />
        {showLabel && (
          <div className="asset_tab_label">
            <div style={{ fontSize: 14, color: "var(--fnt)" }}>{row.title}</div>
            {row.typ === "forex" ? (
              <div
                style={{
                  fontSize: 11,
                  color: "#7C808A",
                  textTransform: "capitalize",
                }}
              >
                {row.typ + "-" + row.chartType}
              </div>
            ) : (
              <div
                style={{
                  fontSize: 11,
                  color: "#7C808A",
                  textTransform: "capitalize",
                }}
              >
                {row.typ}
              </div>
            )}
          </div>
        )}
        {showCloseIcon && showLabel && (
          <CloseOutlined
            onClick={handleClose}
            style={{
              fontSize: 12,
              color: "#9197A4",
              marginLeft: "auto",
              cursor: "pointer",
            }}
          />
        )}
      </div>
    );
  };

  //playsound
  const playAlertSound = () => {
    const audio = new Audio(
      "https://actions.google.com/sounds/v1/alarms/beep_short.ogg",
    );
    audio.play().catch(() => { });
  };

  const [firstTimestamp, setFirstTimeStamp] = React.useState(0);
  function generateMockBarsDbData({
    open,
    high,
    low,
    close,
    time,
    resolution = "1",
  }) {
    try {
      return {
        time,
        open: parseFloat(open.toFixed(5)),
        high: parseFloat(high.toFixed(5)),
        low: parseFloat(low.toFixed(5)),
        close: parseFloat(close.toFixed(5)),
        volume: Math.floor(Math.random() * 1000),
      };
    } catch (e) {
      console.log(e);
    }
  }

  const datafeed = {
    onReady: (callback) => {
      setTimeout(() => {
        callback({
          supported_resolutions: [
            "1",
            "5",
            "15",
            "30",
            "60",
            "120",
            "240",
            "360",
            "720",
            "1D",
            "1W",
            "1M",
          ],
          supports_marks: false,
          supports_timescale_marks: false,
          supports_time: true,
          symbols_types: [{ name: "crypto", value: "crypto" }],
        });
      }, 0);
    },

    searchSymbols: (userInput, exchange, symbolType, onResultReadyCallback) => {
      onResultReadyCallback([
        {
          symbol: userInput,
          full_name: userInput,
          description: userInput,
          exchange: "GPTEX",
          ticker: userInput,
          type: "crypto",
        },
      ]);
    },

    resolveSymbol: async (
      symbolName,
      onSymbolResolvedCallback,
      onResolveErrorCallback,
    ) => {
      console.log(symbolName, "symbolName");
      // // symbolName = symbolName?.split(":")[1];
      // const { data: { result } } = await axios.get(`${consts.BackendUrl}/ownTrade/checkSymbol?symbol=${id}`);
      // // console.log(result, "isOwnTrade")
      var Mode = window.localStorage.getItem("platformmode");
      const currentURL = window.location.href; // full URL as string
      var Precision = 0;

      ///users/getSymbolPercision
      // const { data: { result } } = await axios.post(`${consts.BackendUrl}/users/getSymbolPercision`, {
      //     symbol: symbolName,
      //     type: "binance",
      //     mode: currentURL?.includes("future") ? "future" : "spot"
      // });

      // if (result) {
      //     Precision = result?.precesion
      // }

      const symbolInfo = {
        name: symbolName,
        ticker: symbolName,
        description: symbolName,
        type: "crypto",
        session: "24x7",
        timezone: "Etc/UTC",
        exchange: "Binary Trading",
        minmov: 1,
        pricescale: 100000,
        has_intraday: true,
        intraday_multipliers: [
          "1",
          "5",
          "15",
          "30",
          "60",
          "120",
          "240",
          "360",
          "720",
          "1D",
        ],
        has_daily: true,
        daily_multipliers: ["1"],
        has_weekly_and_monthly: true,
        monthly_multipliers: ["1"],
        supported_resolutions: [
          "1",
          "5",
          "15",
          "30",
          "60",
          "120",
          "240",
          "360",
          "720",
          "1D",
          "1W",
          "1M",
        ],
        volume_precision: 2,
        data_status: "streaming",
      };

      // console.log('Resolved symbol', symbolInfo);

      setTimeout(() => {
        onSymbolResolvedCallback(symbolInfo);
      }, 0);
    },

    getBars: async (
      symbolInfo,
      resolution,
      periodParams,
      onHistoryCallback,
      onErrorCallback,
    ) => {
      const { from, to, firstDataRequest } = periodParams;

      const showEntireHistoryWhenAvailable = true; // set false to strictly return only requested window

      const toMs = (s) => s * 1000;
      const fromMs = toMs(from);
      const toMsVal = toMs(to);

      function isNumericStringOrNumber(v) {
        return v !== null && v !== undefined && v !== "" && !isNaN(v);
      }

      function parseNumericLike(v) {
        const n = Number(v);
        const absStrLen = String(Math.abs(Math.trunc(n))).length;
        if (absStrLen <= 10) return n * 1000; // seconds -> ms
        if (absStrLen >= 13) return n; // ms
        return n > 1e12 ? n : n * 1000;
      }

      // Only append 'Z' for the known naive format "YYYY-MM-DD HH:MM:SS"
      const naiveSpacePattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

      function parseBestDatetimeMs(raw) {
        if (raw == null) return NaN;

        if (isNumericStringOrNumber(raw)) {
          return parseNumericLike(raw);
        }

        const str = String(raw).trim();
        const candidates = new Set();

        // As-is parse (may treat naive strings as local)
        const asIs = Date.parse(str);
        if (!isNaN(asIs)) candidates.add(asIs);

        // If it's the specific naive format, explicitly parse as UTC by appending 'Z'
        if (naiveSpacePattern.test(str)) {
          const withZ = Date.parse(str + "Z");
          if (!isNaN(withZ)) candidates.add(withZ);
        } else {
          // try space->T (sometimes helps), and try withZ as last resort
          const tForm = Date.parse(str.replace(" ", "T"));
          if (!isNaN(tForm)) candidates.add(tForm);
          const withZFallback = Date.parse(str + "Z");
          if (!isNaN(withZFallback)) candidates.add(withZFallback);
        }

        const arr = Array.from(candidates).sort((a, b) => a - b);
        if (arr.length === 0) return NaN;

        // Prefer candidates inside the requested window; if multiple, pick nearest to `to`
        const inWindow = arr.filter((ms) => ms >= fromMs && ms <= toMsVal);
        if (inWindow.length) {
          inWindow.sort(
            (a, b) => Math.abs(toMsVal - a) - Math.abs(toMsVal - b),
          );
          return inWindow[0];
        }

        // Otherwise return the most recent candidate
        return arr[arr.length - 1];
      }

      // Convert resolution (string like "1", "5", "60") to ms when possible
      function resolutionToMs(res) {
        const n = parseInt(res, 10);
        if (!isNaN(n) && n > 0) return n * 60 * 1000;
        // fallback to 1 minute
        return 60 * 1000;
      }

      function normalizeTsToMs(v) {
        const n = Number(v);
        if (!Number.isFinite(n)) return NaN;
        const absStrLen = String(Math.abs(Math.trunc(n))).length;
        if (absStrLen <= 10) return n * 1000;
        return n;
      }

      function normalizeOhlcRows(rawRows = []) {
        if (!Array.isArray(rawRows)) return [];

        const rows = [];
        for (let i = 0; i < rawRows.length; i++) {
          const row = rawRows[i];

          let t;
          let o;
          let h;
          let l;
          let c;

          if (Array.isArray(row)) {
            t = row?.[0];
            o = row?.[1];
            h = row?.[2];
            l = row?.[3];
            c = row?.[4];
          } else if (row && typeof row === "object") {
            t =
              row?.time ??
              row?.ts ??
              row?.t ??
              row?.open_time ??
              row?.start_time ??
              row?.datetime;
            o = row?.open ?? row?.o;
            h = row?.high ?? row?.h;
            l = row?.low ?? row?.l;
            c = row?.close ?? row?.c;
          }

          const timeMs = normalizeTsToMs(t);
          const open = Number(o);
          const high = Number(h);
          const low = Number(l);
          const close = Number(c);

          if (
            Number.isFinite(timeMs) &&
            Number.isFinite(open) &&
            Number.isFinite(high) &&
            Number.isFinite(low) &&
            Number.isFinite(close)
          ) {
            rows.push([timeMs, open, high, low, close]);
          }
        }

        rows.sort((a, b) => a[0] - b[0]);
        return rows;
      }
      try {
        let data;
        if (tab.typ == "forex") {
          const forex = await Axios.post(
            "/users/getforexhistory",
            {
              pair: symbolInfo.name,
              interval: resolution,
            },
            {
              headers: {
                Authorization: localStorage.getItem("Rikosta"),
              },
            },
          );
          data = forex.data;
        } else if (tab.typ === "future") {
          const params = new URLSearchParams({
            symbol: normalizeExchangeSymbol(symbolInfo.name),
            interval: binanceInterval[resolution] || String(resolution),
            startTime: String(fromMs),
            endTime: String(toMsVal),
            limit: "1000",
          });
          const future = await fetch(
            `https://fapi.binance.com/fapi/v1/klines?${params.toString()}`
          );
          const response = await future.json();
          if (!Array.isArray(response)) {
            throw new Error(
              response?.msg ||
              response?.message ||
              "Unexpected Binance futures kline response"
            );
          }
          data = { success: true, result: response };
        }

        if (tab.typ == "forex" && data?.success) {
          const { result } = data;
          const bars = [];
          const rawSamples = [];
          let total = 0,
            parsedAsIsCount = 0,
            parsedWithZCount = 0;

          for (let i = 0; i < result.length; i++) {
            total++;
            const rd = result[i];
            const raw = rd?.datetime;
            if (rawSamples.length < 5) rawSamples.push(raw);

            const asIs = isNumericStringOrNumber(raw)
              ? parseNumericLike(raw)
              : Date.parse(String(raw));
            const asZ = isNumericStringOrNumber(raw)
              ? parseNumericLike(raw)
              : (() => {
                try {
                  return Date.parse(String(raw) + "Z");
                } catch (e) {
                  return NaN;
                }
              })();

            const chosen = parseBestDatetimeMs(raw);

            if (!isNaN(asIs) && asIs === chosen) parsedAsIsCount++;
            else if (!isNaN(asZ) && asZ === chosen) parsedWithZCount++;

            if (isNaN(chosen)) {
              console.warn(
                "[getBars] skipping unparsable datetime:",
                raw,
                "index:",
                i,
              );
              continue;
            }

            const bar = generateMockBarsDbData({
              open: Number(rd?.previous_close),
              high: Number(rd?.high),
              low: Number(rd?.low),
              close: Number(rd?.close),
              time: chosen, // ms
              resolution,
            });

            bars.push(bar);
          }

          // sort ascending (oldest -> newest)
          bars.sort((a, b) => a.time - b.time);

          const filteredBars = bars.filter(
            (bar) => bar.time >= fromMs && bar.time <= toMsVal,
          );

          // If user requested to show entire history and we have older bars than 'from', return them
          if (showEntireHistoryWhenAvailable && bars.length > 0) {
            const hasOlder = bars[0].time < fromMs;
            if (hasOlder) {
              const maxReturn = Math.max(bars.length, filteredBars.length); // change to a fixed cap if required
              const toReturn = bars.slice(0, maxReturn);

              const lastBar = toReturn[toReturn.length - 1];
              window.lastHistoricalBars = window.lastHistoricalBars || {};
              window.lastHistoricalBars[symbolInfo.name] = lastBar;
              console.log(symbolInfo, "symbolInfo");
              onHistoryCallback(toReturn, { noData: false });
              return;
            }
          }

          if (filteredBars.length > 0) {
            const lastBar = filteredBars[filteredBars.length - 1];
            window.lastHistoricalBars = window.lastHistoricalBars || {};
            window.lastHistoricalBars[symbolInfo.name] = lastBar;
            onHistoryCallback(filteredBars, { noData: false });
            console.log(symbolInfo, "symbolInfo");
          } else {
            // No bars within requested window
            onHistoryCallback([], { noData: true });
          }
        } else if (tab.typ === "future" || tab.typ === "commodities") {
          if (tab.typ === "commodities") {
            const data = getCommodityTicker(symbolInfo.name);
            console.log(data, "[getBars]: data commodities");
            const basePrice = Number(
              data?.midprice ?? data?.midPrice ?? data?.mid ?? data?.buy ?? data?.sell,
            );
            let mockBars = generateMockBars(basePrice, 100);
            if (!mockBars.length) {
              mockBars = generateCommodityHistoryBars(
                symbolInfo.name,
                fromMs,
                toMsVal,
                resolution,
              );
            }
            if (mockBars.length > 0) {
              const filteredBars = mockBars.filter(
                (bar) => bar.time >= fromMs && bar.time <= toMsVal,
              );
              if (filteredBars.length > 0) {
                const lastBar = filteredBars[filteredBars.length - 1];
                window.lastHistoricalBars = window.lastHistoricalBars || {};
                window.lastHistoricalBars[symbolInfo.name] = lastBar;
                onHistoryCallback(filteredBars, { noData: false });
              } else {
                onHistoryCallback([], { noData: true });
              }
            } else {
              onHistoryCallback([], { noData: true });
            }
            return;
          }

          const { result } = data || {};

          if (Array.isArray(result) && result.length > 0) {
            const bars = [];
            for (let i = 0; i < result.length; i++) {
              const rd = result[i];
              const bar = generateMockBarsDbData({
                open: Number(rd?.[1]),
                high: Number(rd?.[2]),
                low: Number(rd?.[3]),
                close: Number(rd?.[4]),
                time: Number(rd?.[0]), // ms
                resolution,
              });
              bars.push(bar);
            }
            bars.sort((a, b) => a.time - b.time);
            const filteredBars = bars.filter(
              (bar) => bar.time >= fromMs && bar.time <= toMsVal,
            );
            if (filteredBars.length > 0) {
              const lastBar = filteredBars[filteredBars.length - 1];
              window.lastHistoricalBars = window.lastHistoricalBars || {};
              window.lastHistoricalBars[symbolInfo.name] = lastBar;
              onHistoryCallback(filteredBars, { noData: false });
            } else {
              onHistoryCallback([], { noData: true });
            }
          } else {
            onHistoryCallback([], { noData: true });
          }
        }
      } catch (error) {
        console.error("[getBars]: Error", error);
        onErrorCallback(error);
      }
    },

    subscribeBars: (
      symbolName,
      resolution,
      onRealtimeCallback,
      subscribeUID,
      onResetCacheNeededCallback,
    ) => {
      let lastBar = window.lastHistoricalBars?.[symbolName] || null;
      let commodityResetRequested = false;

      try {
        // resolution to milliseconds map
        const msMap = {
          1: 1 * 60 * 1000,
          5: 5 * 60 * 1000,
          15: 15 * 60 * 1000,
          30: 30 * 60 * 1000,
          60: 60 * 60 * 1000,
          120: 2 * 60 * 60 * 1000,
          240: 4 * 60 * 60 * 1000,
          "1D": 24 * 60 * 60 * 1000,
          "1W": 7 * 24 * 60 * 60 * 1000,
          "1M": 30 * 24 * 60 * 60 * 1000,
        };
        const intervalMs = msMap[resolution] || 60 * 1000;
        console.log(intervalMs, "intervalMs");
        const update = () => {
          const symbol =
            typeof symbolName === "string" ? symbolName : symbolName.name;
          const normalizedSymbol =
            tab.typ === "future"
              ? symbol?.replace(/[_/]/g, "").toUpperCase()
              : symbol;

          const symbolData =
            tab.typ == "forex"
              ? priceRef.current[symbol]
              : tab.typ === "commodities"
                ? getCommodityTicker(symbol)
                : getFutureTicker(normalizedSymbol);

          if (!symbolData) return;
          const price = Number(symbolData?.midprice);
          if (!Number.isFinite(price) || price <= 0) return;

          if (tab.typ === "commodities" && !lastBar) {
            const seededBars = generateCommodityHistoryBars(
              symbol,
              Date.now() - intervalMs * 4,
              Date.now(),
              resolution,
            );

            if (seededBars.length > 0) {
              commodityResetRequested = true;
              lastBar = seededBars[seededBars.length - 1];
              window.lastHistoricalBars = window.lastHistoricalBars || {};
              window.lastHistoricalBars[symbol] = lastBar;
              onResetCacheNeededCallback?.();
              return;
            }
          }

          const now =
            tab?.typ == "forex"
              ? symbolData?.timestamp * 1000
              : Number(symbolData?.timestamp);
          if (!Number.isFinite(now) || now <= 0) return;

          const barTime = now - (now % intervalMs);

          if (!lastBar || lastBar.time !== barTime) {
            // If lastBar exists, use its close as new open
            const open = lastBar ? lastBar.close : price;
            const pad =
              tab.typ === "commodities" ? Math.max(price * 0.00045, 0.02) : 0;

            lastBar = {
              time: barTime,
              open: open,
              high: Math.max(open, price) + pad,
              low: Math.max(0.00001, Math.min(open, price) - pad),
              close: price,
            };

            console.log(lastBar, "lastbar inside if");
          } else {
            // Update existing bar high/low/close
            lastBar.high = Math.max(lastBar.high, price);
            lastBar.low = Math.min(lastBar.low, price);
            lastBar.close = price;
          }

          onRealtimeCallback(lastBar);
        };
        const intervalId = setInterval(update, 1000); // 1s interval is fine
        subscriptionSockets[subscribeUID] = intervalId;
        // if (!state || executeOnce.current) return;
        // if (tab.typ == "future") {
        //   const tpsls = positions?.filter((p) => p?.symbol?.replace("_", "/") === tab?.title);
        //   if (!tpsls?.length) {
        //     handleFutureRemoveAllLines(chartId);
        //     // return;
        //   }

        //   handleFutureRemoveAllLines(chartId);
        //   handleTpSl(tpsls[0]?.take_profit, tpsls[0]?.stop_loss, tpsls[0]?.entry_price);
        // } else if (tab.typ == "forex") {
        //   const activeOrders = openOrders?.filter((p) => p?.symbol === tab?.title?.replace("/", ""));
        //   if (!activeOrders?.length) {
        //     handleRemoveAllLines(chartId);
        //   }

        //   handleRemoveAllLines(chartId);
        //   handleTpSl(activeOrders[0]?.take_profit, activeOrders[0]?.stop_loss, activeOrders[0]?.price);
        // }

        // executeOnce.current = true;
      } catch (error) {
        console.log("Error", error);
      }
    },

    unsubscribeBars: (subscribeUID) => {
      const subscription = subscriptionSockets[subscribeUID];

      if (subscription) {
        clearInterval(subscription);
        delete subscriptionSockets[subscribeUID];
      }
    },
  };

  const defaultProps = {
    symbol: currencyPair.toUpperCase(),
    interval: "1",

    libraryPath: "/charting_library/",
    chartsStorageUrl: "https://saveload.tradingview.com",
    chartsStorageApiVersion: "1.1",
    clientId: "tradingview.com",
    userId: "public_user_id",
    fullscreen: false,
    autosize: true,
    studiesOverrides: {},
  };

  const containerId = `tv_container_${chartId}_${currencyPair.replace(
    "/",
    "_",
  )}`;

  useEffect(() => {
    if (!chartContainerRef.current) return;

    if (
      (tvWidgetRef.current[chartId] &&
        (tab.typ == "forex" || tab.typ === "commodities")) ||
      (futureTvWidgetRef.current[chartId] && tab.typ == "future")
    )
      return;

    if (!window.TradingView?.widget) {
      console.warn("TradingView widget not loaded yet");
      return;
    }

    const timer = setTimeout(
      () => {
        const widget = new window.TradingView.widget({
          symbol: defaultProps.symbol,
          datafeed: datafeed,
          interval: defaultProps.interval,
          container: chartContainerRef.current,
          library_path: defaultProps.libraryPath,
          theme:
            window.localStorage.getItem("theme") === "light" ? "light" : "dark",
          hide_top_toolbar: true,
          hide_symbol_search: true,
          locale: getLanguageFromURL() || "en",
          disabled_features: [
            "use_localstorage_for_settings",
            "header_symbol_search",
            "edit_buttons_in_legend",
            "zoom_control",
            "scrolling",
          ],
          enabled_features: ["study_templates", "inactivity_gaps"],
          charts_storage_url: defaultProps.chartsStorageUrl,
          charts_storage_api_version: defaultProps.chartsStorageApiVersion,
          client_id: defaultProps.clientId,
          user_id: defaultProps.userId,
          fullscreen: defaultProps.fullscreen,
          autosize: defaultProps.autosize,
          studies_overrides: defaultProps.studiesOverrides,
          overrides: {
            "watermark.visible": true,
            "watermark.color": "rgba(255, 255, 255, 1)",
            "watermark.text": "YOUR LOGO",
            "watermark.fontSize": 48,
          },
        });

        // 🟩 register this chart globally in context
        if (tab.typ == "future") {
          futureTvWidgetRef.current[chartId] = widget;
          futureRegisterChart(chartId, widget);
        } else {
          tvWidgetRef.current[chartId] = widget;
          registerChart(chartId, widget);
        }

        widget.onChartReady(() => {
          const chart = widget.chart();
          const isDark = window.localStorage.getItem("theme") === "dark";
          chart.applyOverrides({
            "paneProperties.backgroundType": "image",
            "paneProperties.backgroundImageUrl": "/custum.png",
            "paneProperties.backgroundImageAlignment": "center",
            "paneProperties.backgroundImageOpacity": 10,
            "paneProperties.background": isDark ? "#181A20" : "#fff",
            "scalesProperties.textColor": isDark ? "#fff" : "#181A20",
            "paneProperties.vertGridProperties.color": isDark
              ? "#181A20"
              : "#fff",
            "paneProperties.horzGridProperties.color": isDark
              ? "#181A20"
              : "#fff",
          });
        });
      },
      200 + chartId * 100,
    );

    return () => {
      clearTimeout(timer);
      if (
        (tvWidgetRef.current[chartId] &&
          (tab.typ == "forex" || tab.typ === "commodities")) ||
        (futureTvWidgetRef.current[chartId] && tab.typ == "future")
      ) {
        try {
          tvWidgetRef.current[chartId]?.remove();
          futureTvWidgetRef.current[chartId]?.remove();
        } catch (e) {
          console.error("Error removing TradingView widget:", e);
        }
        delete tvWidgetRef.current[chartId];
        delete futureTvWidgetRef.current[chartId];
        delete lineRefs.current[chartId];
        delete futureLinesRef.current[chartId];
      }

      // 🧹 also unregister from context
      unregisterChart(chartId);
      futureUnregisterChart(chartId);
    };
  }, [mode, chartId, currencyPair, window.localStorage.getItem("theme")]);

  const handleTpSl = (tp, sl, bet) => {
    const chartType = tab.typ == "forex" ? "forex" : "future";
    const widget =
      chartType === "future"
        ? futureTvWidgetRef.current[chartId]
        : tvWidgetRef.current[chartId];
    if (!widget) return;

    const chart = widget.activeChart();
    const ts = Math.floor(Date.now() / 1000);

    const drawLine = (type, price, color, text, width = 1) => {
      if (!price) return;

      // create new line
      chart.createMultipointShape([{ time: ts, price: Number(price) }], {
        shape: "horizontal_line",
        text,
        overrides: {
          linecolor: color,
          linewidth: width,
          textcolor: color,
          linestyle: 2,
        },
        disableSelection: true,
        disableSave: true,
        lock: true,
      });
    };

    drawLine("tp", tp, "#14a043ff", "TP");
    drawLine("sl", sl, "#c00808ff", "SL");
    drawLine("bet", bet, "#B5B5B5 ", "OPEN PRICE", 1);
  };

  const placeForexTrade = async (side) => {
    try {
      if (!quantity || isNaN(quantity) || quantity <= 0) {
        message.error("Please enter a valid Quantity");
        return;
      }
      setLoad((pre) => ({ ...pre, [side]: true }));
      const forexpair = tab.title;
      const symbolKey = "XAU/USD"
      const manualPrice = Number(tradePrice);

      const commodityTicker =
        tab?.typ === "commodities"
          ? getCommodityTicker(forexpair) ||
          getCommodityTicker(symbolKey) ||
          commodityPriceRef?.current?.[getCommodityDomKey(forexpair)]
          : null;
      const forexTicker =
        priceRef.current?.[symbolKey] || priceRef.current?.[forexpair] || null;

      const liveAsk =
        tab?.typ === "commodities"
          ? Number(commodityTicker?.ask)
          : Number(forexTicker?.ask);
      const liveBid =
        tab?.typ === "commodities"
          ? Number(commodityTicker?.bid)
          : Number(forexTicker?.bid);

      const socketPrice = side === "buy" ? liveAsk : liveBid;
      const price =
        Number.isFinite(manualPrice) && manualPrice > 0 ? manualPrice : socketPrice;

      if (!Number.isFinite(price) || price <= 0) {
        message.error("Live price not available. Please wait for socket price.");
        return;
      }

      const pip = forexpair.includes("JPY") ? 0.001 : 0.00001;

      // const volume = quantity * 100000;
      // const margin = (Number(price) * (volume / leverage)).toFixed(2);
      // console.log({ quantity, side, forexpair, price, margin, leverage, vol: volume / leverage, mar: price * (volume / leverage) }, "payload");
      const payload = {
        quantity: quantity,
        side: side,
        pair: forexpair,
        type: "open",
        price,
        margin: (quantity * price * 100000) / leverage,
      };
      if (stopLoss && stopLoss > 0)
        payload.stop_loss =
          side === "buy"
            ? Number(price - stopLoss * pip).toFixed(5)
            : Number(price + stopLoss * pip).toFixed(5);
      if (takeProfit && takeProfit > 0)
        payload.take_profit =
          side === "buy"
            ? Number(price + takeProfit * pip).toFixed(5)
            : Number(price - takeProfit * pip).toFixed(5);

      const placeTradeEndpoint =
        tab?.typ === "commodities"
          ? "/users/placeCommoditiesTrade"
          : "/users/placeForexTrade";

      const { data } = await Axios.post(placeTradeEndpoint, payload, {
        headers: {
          Authorization: localStorage.getItem("nzanzi"),
        },
      });
      if (data?.success) {
        // message.success(data?.message);
        openNotification(quantity, payload.stop_loss, payload.take_profit);
        playAlertSound();
        handleTpSl(payload.take_profit, payload.stop_loss, price);
      } else {
        message.error(data?.message);
      }
      getTradeHistory();
      getWallet();
      setTriggerForexOrders((pre) => !pre);
    } catch (e) {
      console.log(e, "error");
      message.error(
        e?.response?.data?.message || "Can't place order at the moment",
      );
    } finally {
      setLoad({ buy: false, sell: false }); // setLoad(false);
    }
  };

  const placeFutureTrade = async (SIDE) => {
    try {
      if (!quantity || isNaN(quantity) || quantity <= 0) {
        message.error("Please enter a valid Quantity");
      }
      setLoad((pre) => ({ ...pre, [SIDE]: true }));
      const futurePair = tab.title;
      const price = getFutureTicker(futurePair)?.midprice;

      const side = SIDE?.toUpperCase(); // BUY or SELL
      const entryPrice = Number(price);
      const qty = Number(quantity);
      const tpVal = Number(tradeProfit);
      const slVal = Number(tradeLoss);

      let takeProfitPrice = null;
      let stopLossPrice = null;

      // BUY SIDE (LONG)
      if (side === "BUY") {
        if (tpVal > 0) {
          takeProfitPrice = entryPrice + tpVal / qty;
        }
        if (slVal > 0) {
          stopLossPrice = entryPrice - slVal / qty;
        }
      }

      // SELL SIDE (SHORT)
      if (side === "SELL") {
        if (tpVal > 0) {
          takeProfitPrice = entryPrice - tpVal / qty; // price DOWN = profit
        }
        if (slVal > 0) {
          stopLossPrice = entryPrice + slVal / qty; // price UP = loss
        }
      }

      if (side === "BUY") {
        if (takeProfitPrice && takeProfitPrice <= entryPrice) {
          return message.error("For BUY, TP must be above entry price.");
        }
        if (stopLossPrice && stopLossPrice >= entryPrice) {
          return message.error("For BUY, SL must be below entry price.");
        }
      }

      if (side === "SELL") {
        if (takeProfitPrice && takeProfitPrice >= entryPrice) {
          return message.error("For SELL, TP must be below entry price.");
        }
        if (stopLossPrice && stopLossPrice <= entryPrice) {
          return message.error("For SELL, SL must be above entry price.");
        }
      }

      const payload = {
        quantity: qty,
        side: SIDE,
        price: entryPrice,
        symbol: futurePair?.replace("/", "_"),
        type: "market",
        marginMode: "cross",
        tradeLoss: slVal,
        tradeProfit: tpVal,
      };

      if (takeProfitPrice)
        payload.takeProfit = takeProfitPrice > 0 ? takeProfitPrice : 0;
      if (stopLossPrice)
        payload.stopLoss = stopLossPrice > 0 ? stopLossPrice : 0;

      const { data } = await Axios.post("/ownTrade/openPosition", payload, {
        headers: {
          Authorization: localStorage.getItem("nzanzi"),
        },
      });
      if (data?.success) {
        message.success(data?.message);
        playAlertSound();
        // handleTpSl(payload?.takeProfit, payload?.stopLoss, price);
        // handleSetTPSL(payload.stop_loss, payload.take_profit, price);
      } else {
        message.error(data?.message);
      }
      getPositions();
      getWallet();
    } catch (e) {
      console.log(e, "error");
      message.error(e?.response?.data?.message || "Failed to place trade");
    } finally {
      setLoad({ buy: false, sell: false });
    }
  };

  return (
    <Row gutter={0} style={{ height: "100%" }} className="not-cls">
      <div className="head-select-tab" style={{ width: "100%" }}>
        <div style={{ textAlign: "center" }}>
          {tab?.typ === "future" && (
            <AnimatePresence mode="sync" className="">
              <motion.div
                key={tabs.map((t) => t.key).join("-")} // unique key when tabs change
                variants={tabVariants}
                initial="hidden"
                animate="visible"
                className="plus-sym tab-allow-cons"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Tabs
                  onEdit={onEdit}
                  activeKey={activeKey}
                  onChange={setActiveKey}
                  style={{
                    flex: activeFtpage?.typ === "future" ? 0 : 1,
                    marginLeft: !isMobile && "10px",
                  }}
                  hideAdd
                  items={tabs.map((tab, i) => ({
                    label: CustomTabLabel(tab, i, activeKey, onEdit),
                    key: tab.key,
                  }))}
                  className={`${tabs.length <= 1 && "one-tab"} head-tab`}
                  tabBarExtraContent={
                    tabs.length < 6 ? (
                      <Tooltip title="Open New Asset">
                        <motion.div
                          style={{
                            height: "100%",
                          }}
                          whileHover={{ scale: 1.08 }}
                          whileTap={{ scale: 0.97 }}
                        ></motion.div>
                      </Tooltip>
                    ) : null
                  }
                />

                <Button
                  type="text"
                  style={{
                    marginLeft: "8px",
                    padding: "6px 8px",
                    minWidth: "20px",
                    color: "#9197A4",
                  }}
                  className="mob-btn"
                  icon={
                    <div ref={ref2}>
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="7.33325"
                          y="0.333334"
                          width="4"
                          height="17.3333"
                          fill="#9197A4"
                        />
                        <rect
                          x="0.666626"
                          y="11"
                          width="4"
                          height="17.3333"
                          transform="rotate(-90 0.666626 11)"
                          fill="#9197A4"
                        />
                      </svg>
                    </div>
                  }
                  onClick={() => {
                    if (!isRunning) showDrawer();
                    setOpenPortfolioDrawer(false);
                    setCollapsedHistory(true);
                  }}
                />

                {activeFtpage?.typ === "future" && (
                  <div className="icon-tabs">
                    <div
                      className={`tab-icon ${mode === "chart" ? "active" : ""}`}
                      onClick={() => setMode("chart")}
                    >
                      <AreaChartOutlined
                        style={{ color: "var(--fnt)", fontSize: "20px" }}
                        size={"large"}
                      />
                    </div>

                    <div
                      className={`tab-icon ${mode === "placeorder" ? "active" : ""}`}
                      onClick={() => setMode("placeorder")}
                    >
                      <ControlOutlined
                        style={{ color: "var(--fnt)", fontSize: "20px" }}
                      />
                    </div>
                  </div>
                )}
              </motion.div>
            </AnimatePresence>
          )}
          {(tab?.typ === "forex" || tab?.typ === "commodities") && (
            <>
              <Card
                style={{
                  // width: 340,
                  background: "#28292b",
                  borderRadius: 12,
                  border: "1px solid #1f1f1f",
                  marginBottom: 8,
                  padding: "10px",
                }}
                bodyStyle={{ padding: 8 }}
              >
                {/* TOP ROW */}
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Space size={6}>
                    <Text style={{ color: "#e5e7eb", fontWeight: 600 }}>
                      {currencyPair?.toUpperCase()}
                      {console.log(currencyPair, "currencyPairforex")}
                    </Text>
                  </Space>

                  <Tag color="green" style={{ margin: 0 }}>
                    +{percent}%
                  </Tag>
                </div>

                {/* PRICE SECTION */}
                <div style={{ marginTop: 4 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div style={{ color: "#9ca3af", fontSize: 12 }}>Price</div>
                      <div
                        style={{
                          fontSize: 16,
                          fontWeight: 700,
                          color: "#ffffff",
                        }}
                        className={`buybtn-${tab?.typ === "commodities"
                          ? getCommodityDomKey(tab.title)
                          : tab?.typ == "forex"
                            ? tab.title
                            : tab.title?.replace("/", "")
                          }`}
                      >
                        {priceLoading && tab.typ !== "future" ? (
                          <Spin indicator={<LoadingOutlined />} size="small" />
                        ) : (
                          0.0
                        )}
                      </div>
                    </div>

                    <div style={{ textAlign: "right" }}>
                      <Text style={{ color: "#9ca3af", fontSize: 12 }}>
                        Spread
                      </Text>
                      <br />
                      <span style={{ color: "var(--fnt)", marginLeft: "5px" }}>
                        <span
                          className={
                            tab.typ === "commodities"
                              ? `spreadchart-${getCommodityDomKey(tab.title)}`
                              : tab.typ == "future"
                                ? `spreadchart-${tab.title?.replace("/", "")}`
                                : `spreadchart-${tab.title}`
                          }
                        >
                          {priceLoading && tab.typ !== "future" ? (
                            <Spin indicator={<LoadingOutlined />} size="small" />
                          ) : (
                            2.5
                          )}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>

                {/* <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      marginTop: 4,
                      gap: 10,
                    }}
                  >
                    <div style={{
                      background: "#000",
                      borderRadius: 4,
                      padding: 4
                    }}>
                      <div style={{ color: "#9ca3af", fontSize: 11 }}>
                        Mark: <span style={{ color: "#e5e7eb", fontSize: 11 }}>1.1703</span>
                      </div>

                    </div>
                    <div style={{
                      background: "#000",
                      borderRadius: 4,
                      padding: 4
                    }}>
                      <div style={{ color: "#9ca3af", fontSize: 11 }}>
                        Index: <span style={{ color: "#e5e7eb", fontSize: 11 }}>1.1703</span>
                      </div>
                    </div>
                  </div> */}
              </Card>
            </>
          )}
        </div>
      </div>

      {tab?.typ !== "future" && (
        <Col
          className="gutter-row for-mbview "
          span={
            tab?.typ === "future" && screen.xxl
              ? 16
              : tab?.typ === "future" && screen.xl
                ? 12
                : tab?.typ === "future" && screen.lg
                  ? 12
                  : 24
          }
          style={{ height: "100%", position: "relative", display: "flex" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <div
              id={containerId}
              ref={chartContainerRef}
              className="TVChartContainer orba-chart"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          {tab?.typ !== "future" && (
            <div className={`single-chart mb ${compactMode ? "compact" : ""}`}>
              <div
                style={{
                  height: "100%",
                  overflowY: "auto",
                  overflowX: "hidden",
                  width: "130px",
                }}
                className="Trade-btncom"
              >
                <div className="Trade-side-options">
                  <div className="trade-qty-value-wrapper">
                    <div className="display-2 gap-2 trade-qty">
                      {tab?.typ === "forex" ? (
                        <LotDropForex setExpSec={setQuantity}>
                          <div className="quant-c cursor focused mt-5">
                            <>
                              <div className="quanc-h">{"Qty"}</div>

                              <Input
                                size="small"
                                variant="borderless"
                                type="number"
                                onChange={(e) => {
                                  setQuantity(Number(e.target.value));
                                  const pv = Number(e.target.value) * 0.01;
                                  if (tab?.typ == "future" && pv > 0.01) {
                                    setPointValue(pv);
                                  }
                                }}
                                placeholder="0"
                                ref={inputRef}
                                value={quantity}
                              // onFocus={() => setFocused(true)}
                              // onBlur={() => setFocused(false)}
                              />

                              <span className="lot">lot</span>
                            </>
                          </div>
                        </LotDropForex>
                      ) : (
                        <LotDrop setExpSec={setQuantity}>
                          <div className="quant-c cursor focused mt-5">
                            <>
                              <div className="quanc-h">{"Qty"}</div>

                              <Input
                                size="small"
                                variant="borderless"
                                type="number"
                                onChange={(e) => {
                                  setQuantity(Number(e.target.value));
                                  const pv = Number(e.target.value) * 0.01;
                                  if (tab?.typ == "future" && pv > 0.01) {
                                    setPointValue(pv);
                                  }
                                }}
                                placeholder="0"
                                ref={inputRef}
                                value={quantity}
                              // onFocus={() => setFocused(true)}
                              // onBlur={() => setFocused(false)}
                              />

                              <span className="lot">lot</span>
                            </>
                          </div>
                        </LotDrop>
                      )}
                    </div>
                    {(tab?.typ === "forex") && (
                      <div className="quant-c cursor focused mt-5">
                        <div>
                          <div className="quanc-h">{"Price"}</div>

                          <Input
                            size="small"
                            variant="borderless"
                            type="number"
                            onChange={(e) => {
                              setTradePrice(Number(e.target.value));
                            }}
                            placeholder="0"
                            value={tradePrice}
                          // onFocus={() => setFocused(true)}
                          // onBlur={() => setFocused(false)}
                          />

                          <span className="lot">Price</span>
                        </div>
                      </div>
                    )}
                    <div className="trade-value-wrapper">
                      {tab?.typ == "forex" ? (
                        <div
                          className="mt-10 trade-side-box"
                          style={{ padding: "0 15px", color: "var(--fnt)" }}
                        >
                          <div style={{ whiteSpace: "nowrap" }}>
                            Pip Value{" "}
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6C0 2.68629 2.68629 0 6 0C9.31368 0 12 2.68629 12 6ZM6 3.45C5.62722 3.45 5.325 3.75221 5.325 4.125C5.325 4.37353 5.12352 4.575 4.875 4.575C4.62647 4.575 4.425 4.37353 4.425 4.125C4.425 3.25515 5.13018 2.55 6 2.55C6.86982 2.55 7.575 3.25515 7.575 4.125C7.575 4.5515 7.4049 4.9392 7.1298 5.2224C7.07442 5.27934 7.02162 5.33214 6.97122 5.38248C6.84174 5.51184 6.72828 5.62518 6.62874 5.7531C6.49734 5.92194 6.45 6.04608 6.45 6.15V6.6C6.45 6.84852 6.24852 7.05 6 7.05C5.75148 7.05 5.55 6.84852 5.55 6.6V6.15C5.55 5.75688 5.733 5.43864 5.91852 5.20032C6.05574 5.02398 6.22824 4.85178 6.36828 4.71208C6.41052 4.66993 6.44976 4.63073 6.4842 4.59526C6.60276 4.47326 6.675 4.30802 6.675 4.125C6.675 3.75221 6.37278 3.45 6 3.45ZM6 9C6.33138 9 6.6 8.73138 6.6 8.4C6.6 8.06862 6.33138 7.8 6 7.8C5.66862 7.8 5.4 8.06862 5.4 8.4C5.4 8.73138 5.66862 9 6 9Z"
                                fill="#8F929B"
                              />
                            </svg>
                          </div>
                          <div className="mt-5">$ 0.01</div>
                        </div>
                      ) : (
                        <div
                          className="mt-10 trade-side-box"
                          style={{ padding: "0 15px", color: "var(--fnt)" }}
                        >
                          <div style={{ whiteSpace: "nowrap" }}>
                            Point Value{" "}
                            <svg
                              width="12"
                              height="12"
                              viewBox="0 0 12 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6C0 2.68629 2.68629 0 6 0C9.31368 0 12 2.68629 12 6ZM6 3.45C5.62722 3.45 5.325 3.75221 5.325 4.125C5.325 4.37353 5.12352 4.575 4.875 4.575C4.62647 4.575 4.425 4.37353 4.425 4.125C4.425 3.25515 5.13018 2.55 6 2.55C6.86982 2.55 7.575 3.25515 7.575 4.125C7.575 4.5515 7.4049 4.9392 7.1298 5.2224C7.07442 5.27934 7.02162 5.33214 6.97122 5.38248C6.84174 5.51184 6.72828 5.62518 6.62874 5.7531C6.49734 5.92194 6.45 6.04608 6.45 6.15V6.6C6.45 6.84852 6.24852 7.05 6 7.05C5.75148 7.05 5.55 6.84852 5.55 6.6V6.15C5.55 5.75688 5.733 5.43864 5.91852 5.20032C6.05574 5.02398 6.22824 4.85178 6.36828 4.71208C6.41052 4.66993 6.44976 4.63073 6.4842 4.59526C6.60276 4.47326 6.675 4.30802 6.675 4.125C6.675 3.75221 6.37278 3.45 6 3.45ZM6 9C6.33138 9 6.6 8.73138 6.6 8.4C6.6 8.06862 6.33138 7.8 6 7.8C5.66862 7.8 5.4 8.06862 5.4 8.4C5.4 8.73138 5.66862 9 6 9Z"
                                fill="#8F929B"
                              />
                            </svg>
                          </div>
                          <div className="mt-5">$ {pointValue}</div>
                        </div>
                      )}
                      <div
                        className="mt-10 mb-10 trade-side-box"
                        style={{ padding: "0 15px", color: "var(--fnt)" }}
                      >
                        <div style={{ whiteSpace: "nowrap" }}>
                          Margin{" "}
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6C0 2.68629 2.68629 0 6 0C9.31368 0 12 2.68629 12 6ZM6 3.45C5.62722 3.45 5.325 3.75221 5.325 4.125C5.325 4.37353 5.12352 4.575 4.875 4.575C4.62647 4.575 4.425 4.37353 4.425 4.125C4.425 3.25515 5.13018 2.55 6 2.55C6.86982 2.55 7.575 3.25515 7.575 4.125C7.575 4.5515 7.4049 4.9392 7.1298 5.2224C7.07442 5.27934 7.02162 5.33214 6.97122 5.38248C6.84174 5.51184 6.72828 5.62518 6.62874 5.7531C6.49734 5.92194 6.45 6.04608 6.45 6.15V6.6C6.45 6.84852 6.24852 7.05 6 7.05C5.75148 7.05 5.55 6.84852 5.55 6.6V6.15C5.55 5.75688 5.733 5.43864 5.91852 5.20032C6.05574 5.02398 6.22824 4.85178 6.36828 4.71208C6.41052 4.66993 6.44976 4.63073 6.4842 4.59526C6.60276 4.47326 6.675 4.30802 6.675 4.125C6.675 3.75221 6.37278 3.45 6 3.45ZM6 9C6.33138 9 6.6 8.73138 6.6 8.4C6.6 8.06862 6.33138 7.8 6 7.8C5.66862 7.8 5.4 8.06862 5.4 8.4C5.4 8.73138 5.66862 9 6 9Z"
                              fill="#8F929B"
                            />
                          </svg>
                        </div>
                        {tab.typ == "forex" ? (
                          <div className="mt-5">
                            {" "}
                            ${" "}
                            {priceRef.current[tab.title.replace("/", "")]?.buy
                              ? (
                                (quantity *
                                  priceRef.current[tab.title.replace("/", "")]
                                    .buy *
                                  100000) /
                                leverage
                              ).toFixed(2)
                              : 0}
                          </div>
                        ) : (
                          <div className="mt-5">
                            {" "}
                            ${" "}
                            {getFutureTicker(tab.title)?.midprice
                              ? (
                                (quantity *
                                  getFutureTicker(tab.title).midprice) /
                                futureLeverage
                              ).toFixed(2)
                              : 0}
                          </div>
                        )}
                      </div>
                      {tab?.typ == "future" && (
                        <div
                          className="display-5  spread"
                          style={{
                            fontWeight: 500,
                            color: "#7c808a",
                            padding: "0 5px",
                          }}
                        >
                          Leverage{" "}
                          <span
                            style={{ color: "var(--fnt)", marginLeft: "5px" }}
                          >
                            <span className={`spreadchart-${tab.title}`}>
                              {futureLeverage}
                            </span>
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="tp-sl-modal-wrapper">
                    <div
                      onClick={showTpModal}
                      className="cursor trade-side-box"
                      style={{
                        padding: "10px",
                        color: "var(--fnt)",
                        background: "var(--active3)",
                      }}
                    >
                      TP - $ {tradeProfit}
                    </div>
                    <Modal
                      open={isModalTpOpen}
                      onCancel={handleTpCancel}
                      footer={null}
                      width={400}
                      closeIcon={false}
                      className="trade_modal"
                    >
                      <h4>CLOSE TRADE AT PROFIT</h4>

                      <div className={`quant-c cursor focused`}>
                        <div className="quanc-h">
                          {tab?.typ == "forex" ? "Pips" : "Points"}{" "}
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6C0 2.68629 2.68629 0 6 0C9.31368 0 12 2.68629 12 6ZM6 3.45C5.62722 3.45 5.325 3.75221 5.325 4.125C5.325 4.37353 5.12352 4.575 4.875 4.575C4.62647 4.575 4.425 4.37353 4.425 4.125C4.425 3.25515 5.13018 2.55 6 2.55C6.86982 2.55 7.575 3.25515 7.575 4.125C7.575 4.5515 7.4049 4.9392 7.1298 5.2224C7.07442 5.27934 7.02162 5.33214 6.97122 5.38248C6.84174 5.51184 6.72828 5.62518 6.62874 5.7531C6.49734 5.92194 6.45 6.04608 6.45 6.15V6.6C6.45 6.84852 6.24852 7.05 6 7.05C5.75148 7.05 5.55 6.84852 5.55 6.6V6.15C5.55 5.75688 5.733 5.43864 5.91852 5.20032C6.05574 5.02398 6.22824 4.85178 6.36828 4.71208C6.41052 4.66993 6.44976 4.63073 6.4842 4.59526C6.60276 4.47326 6.675 4.30802 6.675 4.125C6.675 3.75221 6.37278 3.45 6 3.45ZM6 9C6.33138 9 6.6 8.73138 6.6 8.4C6.6 8.06862 6.33138 7.8 6 7.8C5.66862 7.8 5.4 8.06862 5.4 8.4C5.4 8.73138 5.66862 9 6 9Z"
                              fill="#8F929B"
                            />
                          </svg>
                        </div>

                        <Input
                          size="small"
                          variant="borderless"
                          inputMode="numeric"
                          maxLength={15}
                          onChange={(e) => {
                            if (tab.typ == "forex") {
                              handlePipChange(e.target.value, "tp");
                            } else {
                              handlePointChange(e.target.value, "tp");
                            }
                          }}
                          placeholder="-"
                          value={takeProfit}
                          onFocus={() => setFocused(true)}
                          onBlur={() => setFocused(false)}
                        />
                      </div>

                      <div className={`quant-c cursor focused mt-10`}>
                        <div className="quanc-h">
                          Profit in money{" "}
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6C0 2.68629 2.68629 0 6 0C9.31368 0 12 2.68629 12 6ZM6 3.45C5.62722 3.45 5.325 3.75221 5.325 4.125C5.325 4.37353 5.12352 4.575 4.875 4.575C4.62647 4.575 4.425 4.37353 4.425 4.125C4.425 3.25515 5.13018 2.55 6 2.55C6.86982 2.55 7.575 3.25515 7.575 4.125C7.575 4.5515 7.4049 4.9392 7.1298 5.2224C7.07442 5.27934 7.02162 5.33214 6.97122 5.38248C6.84174 5.51184 6.72828 5.62518 6.62874 5.7531C6.49734 5.92194 6.45 6.04608 6.45 6.15V6.6C6.45 6.84852 6.24852 7.05 6 7.05C5.75148 7.05 5.55 6.84852 5.55 6.6V6.15C5.55 5.75688 5.733 5.43864 5.91852 5.20032C6.05574 5.02398 6.22824 4.85178 6.36828 4.71208C6.41052 4.66993 6.44976 4.63073 6.4842 4.59526C6.60276 4.47326 6.675 4.30802 6.675 4.125C6.675 3.75221 6.37278 3.45 6 3.45ZM6 9C6.33138 9 6.6 8.73138 6.6 8.4C6.6 8.06862 6.33138 7.8 6 7.8C5.66862 7.8 5.4 8.06862 5.4 8.4C5.4 8.73138 5.66862 9 6 9Z"
                              fill="#8F929B"
                            />
                          </svg>
                        </div>

                        <Input
                          size="small"
                          variant="borderless"
                          inputMode="numeric"
                          maxLength={15}
                          onChange={(e) => {
                            if (tab.typ == "forex") {
                              handleTradeProfitChange(e.target.value, "tp");
                            } else {
                              handleFutureProfitChange(e.target.value, "tp");
                            }
                          }}
                          placeholder="+$"
                          value={tradeProfit}
                          onFocus={() => setFocused(true)}
                          onBlur={() => setFocused(false)}
                        />
                      </div>

                      <div className="display-1 mt-20">
                        <button
                          className="trade_cancel_btn cursor"
                          onClick={handleTpCancel}
                        >
                          Cancel
                        </button>
                        <button
                          className="trade_apply_btn cursor"
                          onClick={handleTpOk}
                        >
                          Apply
                        </button>
                      </div>
                    </Modal>

                    <div
                      onClick={showSLModal}
                      className="cursor trade-side-box"
                      style={{
                        padding: "10px",
                        color: "var(--fnt)",
                        background: "var(--active3)",
                      }}
                    >
                      SL - $ {tradeLoss}
                    </div>
                    <Modal
                      open={isModalSlOpen}
                      onCancel={handleSlCancel}
                      footer={null}
                      width={400}
                      closeIcon={false}
                      className="trade_modal"
                    >
                      <h4>CLOSE TRADE AT LOSS</h4>
                      <div className={`quant-c cursor focused`}>
                        <div className="quanc-h">
                          {tab?.typ == "forex" ? "Pips" : "Points"}{" "}
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6C0 2.68629 2.68629 0 6 0C9.31368 0 12 2.68629 12 6ZM6 3.45C5.62722 3.45 5.325 3.75221 5.325 4.125C5.325 4.37353 5.12352 4.575 4.875 4.575C4.62647 4.575 4.425 4.37353 4.425 4.125C4.425 3.25515 5.13018 2.55 6 2.55C6.86982 2.55 7.575 3.25515 7.575 4.125C7.575 4.5515 7.4049 4.9392 7.1298 5.2224C7.07442 5.27934 7.02162 5.33214 6.97122 5.38248C6.84174 5.51184 6.72828 5.62518 6.62874 5.7531C6.49734 5.92194 6.45 6.04608 6.45 6.15V6.6C6.45 6.84852 6.24852 7.05 6 7.05C5.75148 7.05 5.55 6.84852 5.55 6.6V6.15C5.55 5.75688 5.733 5.43864 5.91852 5.20032C6.05574 5.02398 6.22824 4.85178 6.36828 4.71208C6.41052 4.66993 6.44976 4.63073 6.4842 4.59526C6.60276 4.47326 6.675 4.30802 6.675 4.125C6.675 3.75221 6.37278 3.45 6 3.45ZM6 9C6.33138 9 6.6 8.73138 6.6 8.4C6.6 8.06862 6.33138 7.8 6 7.8C5.66862 7.8 5.4 8.06862 5.4 8.4C5.4 8.73138 5.66862 9 6 9Z"
                              fill="#8F929B"
                            />
                          </svg>
                        </div>

                        <Input
                          size="small"
                          variant="borderless"
                          type="number"
                          onChange={(e) => {
                            if (tab?.typ == "forex") {
                              handlePipChange(e.target.value, "sl");
                            } else {
                              handlePointChange(e.target.value, "sl");
                            }
                          }}
                          placeholder="-"
                          ref={inputRef}
                          value={stopLoss}
                        />
                      </div>
                      <div className={`quant-c cursor focused mt-10`}>
                        <div className="quanc-h">
                          Loss in money{" "}
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M12 6C12 9.31368 9.31368 12 6 12C2.68629 12 0 9.31368 0 6C0 2.68629 2.68629 0 6 0C9.31368 0 12 2.68629 12 6ZM6 3.45C5.62722 3.45 5.325 3.75221 5.325 4.125C5.325 4.37353 5.12352 4.575 4.875 4.575C4.62647 4.575 4.425 4.37353 4.425 4.125C4.425 3.25515 5.13018 2.55 6 2.55C6.86982 2.55 7.575 3.25515 7.575 4.125C7.575 4.5515 7.4049 4.9392 7.1298 5.2224C7.07442 5.27934 7.02162 5.33214 6.97122 5.38248C6.84174 5.51184 6.72828 5.62518 6.62874 5.7531C6.49734 5.92194 6.45 6.04608 6.45 6.15V6.6C6.45 6.84852 6.24852 7.05 6 7.05C5.75148 7.05 5.55 6.84852 5.55 6.6V6.15C5.55 5.75688 5.733 5.43864 5.91852 5.20032C6.05574 5.02398 6.22824 4.85178 6.36828 4.71208C6.41052 4.66993 6.44976 4.63073 6.4842 4.59526C6.60276 4.47326 6.675 4.30802 6.675 4.125C6.675 3.75221 6.37278 3.45 6 3.45ZM6 9C6.33138 9 6.6 8.73138 6.6 8.4C6.6 8.06862 6.33138 7.8 6 7.8C5.66862 7.8 5.4 8.06862 5.4 8.4C5.4 8.73138 5.66862 9 6 9Z"
                              fill="#8F929B"
                            />
                          </svg>
                        </div>

                        <Input
                          size="small"
                          variant="borderless"
                          type="number"
                          onChange={(e) => {
                            if (tab?.typ == "forex") {
                              handleStopLossChange(e.target.value);
                            } else {
                              handleFutureProfitChange(e.target.value, "sl");
                            }
                          }}
                          placeholder="+$"
                          ref={inputRef}
                          value={tradeLoss}
                        />
                      </div>
                      <div className="display-1 mt-20">
                        <button
                          className="trade_cancel_btn cursor"
                          onClick={handleSlCancel}
                        >
                          Cancel
                        </button>
                        <button
                          className="trade_apply_btn cursor"
                          onClick={handleSlOk}
                        >
                          Apply
                        </button>
                      </div>{" "}
                    </Modal>
                  </div>
                </div>
                {tab?.typ === "future" && (
                  <div
                    style={{
                      position: "sticky",
                      bottom: "0",
                      background: "var(--bg-mn)",
                    }}
                    className={`chart-responsebtn a3 py-${isCompact ? 1 : 3}`}
                  >
                    <motion.div
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      initial={{ opacity: 0, y: 50 }}
                      transition={{ duration: 0.5 }}
                      className="hig-btn"
                    >
                      <Button
                        className={`trade-buy-btn ${isCompact
                          ? "text-xs buy-response-sm"
                          : "text-sm buy-response"
                          }`}
                        onClick={() => {
                          console.log("Quantity:", quantity);
                          if (quantity === "" || quantity === 0) {
                            message.warning("Please Add Quantity");
                          } else {
                            if (tab?.typ == "forex") {
                              placeForexTrade("buy");
                            } else {
                              placeFutureTrade("buy");
                            }
                          }
                        }}
                        disabled={load.buy || isRunning}
                      >
                        {load.buy
                          ? "Placing Trade..."
                          : tab?.typ == "forex" || tab?.typ === "commodities"
                            ? "BUY / LONG"
                            : "Open Long"}

                        <div style={{ fontSize: "13px" }} className="btn-count">
                          <span
                            className={`buybtn-${tab?.typ == "forex"
                              ? tab.title
                              : tab.title?.replace("/", "")
                              }`}
                          >
                            0.0000
                          </span>
                        </div>
                      </Button>
                    </motion.div>

                    {/* <div
                  className="display-5 p-10 spread"
                  style={{ fontWeight: 500, color: "#7c808a" }}
                  onClick={openNotification}
                >
                  Spread{" "}
                  <span style={{ color: "var(--fnt)", marginLeft: "5px" }}>
                    <span
                      className={
                        tab.typ == "future"
                          ? `spreadchart-${tab.title?.replace("/", "")}`
                          : `spreadchart-${tab.title}`
                      }
                    >
                      2.5
                    </span>
                  </span>
                </div> */}

                    <motion.div
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      initial={{ opacity: 0, y: 50 }}
                      transition={{ duration: 0.5 }}
                      className="hig-btn"
                    >
                      <Button
                        className={`trade-sell-btn ${isCompact ? "text-xs px-2 py-1" : "text-sm px-4 py-2"
                          }`}
                        onClick={() => {
                          if (quantity === "" || quantity === 0) {
                            message.warning("Please Add Quantity");
                          } else {
                            if (tab?.typ == "forex") {
                              placeForexTrade("sell");
                            } else {
                              placeFutureTrade("sell");
                            }
                          }
                        }}
                        disabled={load.sell || isRunning}
                      >
                        {/* <img
                        src={lower}
                        style={{
                          width: isCompact ? 16 : 24,
                          height: isCompact ? 16 : 24,
                        }}
                      /> */}
                        {load.sell
                          ? "Placing Trade..."
                          : tab?.typ == "forex" || tab?.typ === "commodities"
                            ? " SELL / SHORT"
                            : "Open Short"}

                        <div style={{ fontSize: "13px" }} className="btn-count">
                          <span
                            className={`sellbtn-${tab?.typ == "forex"
                              ? tab.title
                              : tab.title?.replace("/", "")
                              }`}
                          >
                            0.0000
                          </span>
                        </div>
                      </Button>
                    </motion.div>
                  </div>
                )}
                {(tab?.typ === "forex" || tab?.typ === "commodities") && (
                  <div
                    style={{
                      position: "sticky",
                      bottom: "0",
                      background: "var(--bg-mn)",
                    }}
                    className={`chart-responsebtn buy-sell-container a3 py-${isCompact ? 1 : 3}`}
                  >
                    <motion.div
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      initial={{ opacity: 0, y: 50 }}
                      transition={{ duration: 0.5 }}
                      className="hig-btn forex"
                    >
                      <Button
                        className={`trade-buy-btn ${isCompact
                          ? "text-xs buy-response-sm"
                          : "text-sm buy-response"
                          }`}
                        onClick={() => {
                          console.log("Quantity:", quantity);
                          if (quantity === "" || quantity === 0) {
                            message.warning("Please Add Quantity");
                          } else {
                            if (
                              tab?.typ == "forex" ||
                              tab?.typ === "commodities"
                            ) {
                              placeForexTrade("buy");
                            } else {
                              placeFutureTrade("buy");
                            }
                          }
                        }}
                        disabled={load.buy || isRunning}
                      >
                        {load.buy
                          ? "Placing Trade..."
                          : tab?.typ == "forex"
                            ? "BUY / LONG"
                            : "Open Long"}

                        <div style={{ fontSize: "13px" }} className="btn-count">
                          <span
                            className={`buybtn-${tab?.typ === "commodities"
                              ? getCommodityDomKey(tab.title)
                              : tab?.typ == "forex"
                                ? ""
                                : tab.title?.replace("/", "")
                              }`}
                          >
                            {tradePrice || "0.0000"}
                          </span>
                        </div>
                      </Button>
                    </motion.div>

                    <motion.div
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      initial={{ opacity: 0, y: 50 }}
                      transition={{ duration: 0.5 }}
                      className="hig-btn"
                    >
                      <Button
                        className={`trade-sell-btn ${isCompact ? "text-xs px-2 py-1" : "text-sm px-4 py-2"
                          }`}
                        onClick={() => {
                          if (quantity === "" || quantity === 0) {
                            message.warning("Please Add Quantity");
                          } else {
                            if (
                              tab?.typ == "forex" ||
                              tab?.typ === "commodities"
                            ) {
                              placeForexTrade("sell");
                            } else {
                              placeFutureTrade("sell");
                            }
                          }
                        }}
                        disabled={load.sell || isRunning}
                      >
                        {load.sell
                          ? "Placing Trade..."
                          : tab?.typ == "forex"
                            ? " SELL / SHORT"
                            : "Open Short"}

                        <div style={{ fontSize: "13px" }} className="btn-count">
                          <span
                            className={`sellbtn-${tab?.typ === "commodities"
                              ? getCommodityDomKey(tab.title)
                              : tab?.typ == "forex"
                                ? tab.title
                                : tab.title?.replace("/", "")
                              }`}
                          >
                            {tradePrice || "0.0000"}
                          </span>
                        </div>
                      </Button>
                    </motion.div>
                  </div>
                )}
              </div>
            </div>
          )}
        </Col>
      )}

      {tab?.typ === "future" && mode === "chart" && (
        <Col
          className="gutter-row  forex-mbview"
          span={
            tab?.typ === "future" && screen.xxl
              ? 16
              : tab?.typ === "future" && screen.xl
                ? 12
                : tab?.typ === "future" && screen.lg
                  ? 12
                  : 24
          }
          style={{ height: "100%", position: "relative", display: "flex" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <div
              id={containerId}
              ref={chartContainerRef}
              className="TVChartContainer orba-chart"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </Col>
      )}
      {tab?.typ === "future" && screen.lg && (
        <Col
          className="gutter-row for-mbview forex-mbview"
          span={
            tab?.typ === "future" && screen.xxl
              ? 4
              : tab?.typ === "future" && screen.xl
                ? 6
                : 6
          }
          style={{
            height: "100%",
            position: "relative",
            border: "1px solid #f7a60047 ",
          }}
        >
          <OrderBook
            asks={orderBook.asks}
            bids={orderBook?.bids}
            midPrice={orderBookMidPrice}
          />
        </Col>
      )}

      {tab?.typ === "future" && screen.lg && (
        <Col
          className="gutter-row for-mbview forex-mbview"
          span={
            tab?.typ === "future" && screen.xxl
              ? 4
              : tab?.typ === "future" && screen.xl
                ? 6
                : 6
          }
          style={{ height: "100%", position: "relative" }}
        >
          <PlaceOrder />
        </Col>
      )}

      {!screen.lg && mode === "placeorder" && tab?.typ === "future" && (
        <Col className="gutter-row " style={{ height: "100%" }} span={12}>
          <OrderBook
            asks={orderBook.asks}
            bids={orderBook?.bids}
            midPrice={orderBookMidPrice}
          />
        </Col>
      )}
      {!screen.lg && mode === "placeorder" && tab?.typ === "future" && (
        <Col className="gutter-row " style={{ height: "100%" }} span={12}>
          <PlaceOrder />
        </Col>
      )}

      { }

      {/* <Col span={24}>
        <div className="toggle-wrapper display-2">
          <Button
            type={active === "chart" ? "primary" : "default"}
            icon={<LineChartOutlined />}
            onClick={() => setActive("chart")}
            className="toggle-btn"
          >
            Chart
          </Button>

          <Button
            type={active === "orderbook" ? "primary" : "default"}
            icon={<TableOutlined />}
            onClick={() => setActive("orderbook")}
            className="toggle-btn"
          >
            Orderbook
          </Button>
        </div>

      </Col> */}
    </Row>
  );
}
